export const menuData = [
    {
      title: "Booking",
      submenu: [
        {id:0, itemId:"booking_0", label: "My Bookings" ,icon:"../../../../assets/image/icons/teeTime.svg" },
        {id:1, itemId:"booking_1", label: "Find Tee Times" ,icon:"../../../../assets/image/icons/teeTime.svg" },
        {id:2, itemId:"booking_2", label: "Stay & Play",icon:"../../../../assets/image/icons/stayPlay.svg" },
        {id:3, itemId:"booking_3", label: "Driving Range",icon:"../../../../assets/image/icons/drivingRange.svg" },
        {id:4, itemId:"booking_4", label: "Other Facilities",icon:"../../../../assets/image/icons/myBooking.svg" },
        {id:5, itemId:"booking_5", label: "Join Games / Find Players", color: "rgb(35 31 32 / 50%)",icon:"../../../../assets/image/icons/findPlayer.svg" },
        // {id:6, itemId:"booking_6", label: "My Bookings",icon:"../../../../assets/image/icons/myBooking.svg" },
      ],
    },
    {
      title: "Events & Scoring",
      submenu: [
        {id:1, itemId:"eventScoring_1", label: "New Game / Score Round",icon:"../../../../assets/image/icons/scoreRound.svg" },
        {id:2, itemId:"eventScoring_2", label: "Find / Join Tournaments",icon:"../../../../assets/image/icons/tournament.svg" },
        {id:6, itemId:"eventScoring_6", label: "Tournament Scoring",icon:".../../../../assets/image/icons/liveScore.svg" },
        {id:4, itemId:"eventScoring_4", label: "View Scorecards",icon:"../../../../assets/image/icons/viewScore.svg" },
        {id:5, itemId:"eventScoring_5", label: "Statistics",icon:"../../../../assets/image/icons/performance.svg" },
        {id:6, itemId:"eventScoring_6", label: "Performance at Golf Club",icon:"../../../../assets/image/icons/performance.svg" },
        // {id:7, itemId:"eventScoring_7", label: "Matchplay Scoring",icon:"../../../../assets/image/icons/performance.svg" },
        // {id:8, itemId:"eventScoring_8", label: "Matchplay Matches",icon:"../../../../assets/image/icons/performance.svg" },
        // {id:3 ,label: "Live Scoring",icon:"../../../../assets/image/icons/liveScore.svg" },
      ],
    },
    {
      title: "Handicap",
      submenu: [
        {id:1, itemId:"handicap_1", label: "National Handicap Subscription",icon:"../../../../assets/image/icons/subscription.svg" },
        {id:2, itemId:"handicap_2", label: "View Handicap & History",icon:"../../../../assets/image/icons/history.svg" },
        {id:3, itemId:"handicap_3", label: "Peer Review",icon:"../../../../assets/image/icons/peerReview.svg" },
        {id:4, itemId:"handicap_4", label: "Handicap Calculator",icon:"../../../../assets/image/icons/handicapCalculater.svg" },
      ],
    },
    {
      title: "Memberships",
      // submenu: [
      //   {id:1, itemId:"mship_1", label: "Profile / eWallet",icon:"../../../../assets/image/icons/eWallet.svg" },
      //   {id:3, itemId:"mship_2", label: "Membership",icon:"../../../../assets/image/icons/membershipMenu.svg" },
      //   {id:4, itemId:"mship_3", label: "Discount Profiles",icon:"../../../../assets/image/icons/discount.svg" },
      //   {id:5, itemId:"mship_4", label: "Friends",icon:"../../../../assets/image/icons/friends.svg" },
      //   {id:6, itemId:"mship_5", label: "Notifications",icon:"../../../../assets/image/icons/notificationMenu.svg" },
      //   {id:7, itemId:"mship_6", label: "FAQs",icon:"../../../../assets/image/icons/faqs.svg" },
      //   // {id:2 ,label: "Old Membership",icon:"../../../../assets/image/icons/membershipMenu.svg" },
      // ],
    },
    {
      title: "Essentials",
      submenu: [
        {id:1, itemId:"essentials_1", label: "Account / eWallet",icon:"../../../../assets/image/icons/eWallet.svg" },
        // {id:3, itemId:"essentials_3", label: "Membership",icon:"../../../../assets/image/icons/membershipMenu.svg" },
        {id:4, itemId:"essentials_4", label: "Discount Profiles",icon:"../../../../assets/image/icons/discount.svg" },
        {id:5, itemId:"essentials_5", label: "Friends",icon:"../../../../assets/image/icons/friends.svg" },
        {id:6, itemId:"essentials_6", label: "Notifications",icon:"../../../../assets/image/icons/notificationMenu.svg" },
        {id:7, itemId:"essentials_7", label: "FAQs",icon:"../../../../assets/image/icons/faqs.svg" },
        // {id:2 ,label: "Old Membership",icon:"../../../../assets/image/icons/membershipMenu.svg" },
      ],
    },
    {
      title: "Settings",
      submenu: [
        {id:1, itemId:"settings_1", label: "About",icon:"../../../../assets/image/icons/aboutMenu.svg" },
        {id:2, itemId:"settings_2", label: "Change Password",icon:"../../../../assets/image/icons/changePassword.svg" },
        {id:3, itemId:"settings_3", label: "Help Content",icon:"../../../../assets/image/icons/content.svg" },
        {id:4, itemId:"settings_4", label: "Send Feedback",icon:"../../../../assets/image/icons/sendFeedback.svg" },
        {id:5, itemId:"settings_5", label: "Contact Us",icon:"../../../../assets/image/icons/contactUs.svg" },
        {id:6, itemId:"settings_6", label: "Share App",icon:"../../../../assets/image/icons/share.svg" },
        {id:7, itemId:"settings_7", label: "Delete Account",icon:"../../../../assets/image/icons/deleteMenu.svg" },
      ],
    },
  ];
